<template>
  <div class="card-body">
    <div class="brand-wrapper">
      <img src="@/assets/images/logo.svg"
        alt="logo"
        class="logo">
    </div>
    <p class="login-card-description">Aanmelden <small>met scanner</small></p>

  <div style="height: 50px; border: 1px black solid; margin-bottom: 20px">
    <div v-if="validationSuccess" class="validation-success">Inloggen</div>

    <div v-if="validationFailure" class="validation-failure">
      Niet geldig!
    </div>

    <div v-if="error" class="validation-failure">
      Er ging iets mis, probeer later opnieuw.
    </div>

    <div v-if="validationPending" class="validation-pending">
      Valideren...
    </div>
  </div>
      <router-link
        :to="{name: 'choose'}"
      class="forgot-password-link">
      <span class="mdi mdi-arrow-left"></span> Andere methode
    </router-link>
  </div>
</template>

<script>
import { loginQR } from '@/api';
import { UnautorisedApiError } from '@/api/apiErrors';
import { addDeviceNameToUrl } from '@/utils/device';

export default {

  data() {
    return {
      isValid: undefined,
      result: null,
      error: false,
      validationPending: false,
      initPending: true,
      scannedValue: '',
    };
  },

  computed: {
    validationSuccess() {
      return this.isValid === true;
    },

    validationFailure() {
      return this.isValid === false && !this.validationPending;
    },
  },

  mounted() {
    this.inputHandler = (e) => {
      if (e.key === 'Enter') {
        this.onDecode(this.scannedValue);
        this.scannedValue = '';
      } else if (e.key.length === 1) {
        this.scannedValue += e.key;
      }
    };
    document.body.addEventListener('keydown', this.inputHandler);
  },

  destroyed() {
    document.body.removeEventListener('keydown', this.inputHandler);
  },

  methods: {
    onInit(promise) {
      promise.catch(console.error).then(this.resetValidationState);
    },

    resetValidationState() {
      this.isValid = undefined;
      this.error = false;
    },

    async onDecode(content) {
      this.result = content;

      try {
        this.validationPending = true;
        await loginQR(content.replace('URL:', ''));
        window.location.href = addDeviceNameToUrl(`${process.env.VUE_APP_BASE_URL}/v1/authorize`);
      } catch (e) {
        if (e instanceof UnautorisedApiError) {
          this.isValid = false;
        } else {
          this.error = true;
        }
        this.validationPending = false;
        // some more delay, so users have time to read the message
        await this.timeout(2000);
        console.error(e);
      }
    },

    timeout(ms) {
      return new Promise((resolve) => {
        window.setTimeout(resolve, ms);
      });
    },
  },
};
</script>

<style scoped>
.validation-success,
.validation-failure,
.validation-pending {
  background-color: rgba(255, 255, 255, 0.8);
  text-align: center;
  font-weight: bold;
  font-size: 1.4rem;
  padding: 10px;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
}
.validation-success {
  color: green;
}
.validation-failure {
  color: red;
}
.btn {
  position: absolute;
  top: 1rem;
  right: 2rem;
}
</style>
